export default class Recorder {
  constructor() {
    this.reset();
  }
  reset() {
    this.TIMINGS = [];
    this.LETTERS = [];
    this.ACTIONS = [];
    this._startTime = null;
  }

  add(letter, action = "+") {
    if (this._startTime === null) this._startTime = Date.now();
    this.TIMINGS.push(Date.now() - this._startTime);
    this.LETTERS.push(letter);
    this.ACTIONS.push(action);

    this._startTime = Date.now();
  }

  remove(letter = "*", action = "-") {
    this.TIMINGS.push(Date.now() - this._startTime);
    this.LETTERS.push(letter);
    this.ACTIONS.push(action);

    this._startTime = Date.now();
  }

  get values() {
    return {
      timings: this.TIMINGS,
      letters: this.LETTERS,
      actions: this.ACTIONS,
    };
  }
}
